export const DEMO_AIRLINES = [
  { value: "NH", label: "ANA (NH)" },
  { value: "A3", label: "Aegean Airlines (A3)" },
  { value: "EI", label: "Aer Lingus (EI)" },
  { value: "SU", label: "Aeroflot (SU)" },
  { value: "AR", label: "Aerolineas Argentinas (AR)" },
  { value: "AM", label: "Aeromexico (AM)" },
  { value: "AC", label: "Air Canada (AC)" },
  { value: "CA", label: "Air China (CA)" },
  { value: "EN", label: "Air Dolomiti (EN)" },
  { value: "UX", label: "Air Europa (UX)" },
  { value: "AF", label: "Air France (AF)" },
  { value: "AI", label: "Air India (AI)" },
  { value: "NZ", label: "Air New Zealand (NZ)" },
  { value: "JU", label: "Air Serbia (JU)" },
  { value: "TS", label: "Air Transat (TS)" },
  { value: "AS", label: "Alaska Airlines (AS)" },
  { value: "G4", label: "Allegiant Air (G4)" },
  { value: "AA", label: "American Airlines (AA)" },
  { value: "OZ", label: "Asiana Airlines (OZ)" },
  { value: "AV", label: "Avianca (AV)" },
  { value: "AD", label: "Azul Airlines (AD)" },
  { value: "JD", label: "Beijing Capital Airlines (JD)" },
  { value: "BA", label: "British Airways (BA)" },
  { value: "SN", label: "Brussels Airlines (SN)" },
  { value: "CX", label: "Cathay Pacific (CX)" },
  { value: "CI", label: "China Airlines (CI)" },
  { value: "MU", label: "China Eastern Airlines (MU)" },
  { value: "CZ", label: "China Southern Airlines (CZ)" },
  { value: "DE", label: "Condor (DE)" },
  { value: "CM", label: "Copa Airlines (CM)" },
  { value: "OU", label: "Croatia Airlines (OU)" },
  { value: "OK", label: "Czech Airlines (OK)" },
  { value: "DL", label: "Delta Air Lines (DL)" },
  { value: "LY", label: "EL AL (LY)" },
  { value: "BR", label: "EVA Air (BR)" },
  { value: "MS", label: "EgyptAir (MS)" },
  { value: "EK", label: "Emirates (EK)" },
  { value: "ET", label: "Ethiopian Airlines (ET)" },
  { value: "EW", label: "Eurowings (EW)" },
  { value: "FJ", label: "Fiji Airways (FJ)" },
  { value: "AY", label: "Finnair (AY)" },
  { value: "F9", label: "Frontier Airlines (F9)" },
  { value: "G3", label: "GOL (G3)" },
  { value: "GA", label: "Garuda Indonesia (GA)" },
  { value: "GF", label: "Gulf Air Bahrain (GF)" },
  { value: "HU", label: "Hainan Airlines (HU)" },
  { value: "HA", label: "Hawaiian Airlines (HA)" },
  { value: "AZ", label: "ITA (AZ)" },
  { value: "IB", label: "Iberia (IB)" },
  { value: "FI", label: "Icelandair (FI)" },
  { value: "JL", label: "JAL (JL)" },
  { value: "B6", label: "JetBlue Airways (B6)" },
  { value: "JQ", label: "Jetstar Airways (JQ)" },
  { value: "KL", label: "KLM (KL)" },
  { value: "KE", label: "Korean Air (KE)" },
  { value: "KU", label: "Kuwait Airways (KU)" },
  { value: "LA", label: "LATAM Airlines (LA)" },
  { value: "LO", label: "LOT Polish Airlines (LO)" },
  { value: "LH", label: "Lufthansa (LH)" },
  { value: "MH", label: "Malaysia Airlines (MH)" },
  { value: "ME", label: "Middle East Airlines (ME)" },
  { value: "DY", label: "Norwegian Air Shuttle (DY)" },
  { value: "WY", label: "Oman Air (WY)" },
  { value: "PK", label: "Pakistan International Airlines (PK)" },
  { value: "PR", label: "Philippine Airlines (PR)" },
  { value: "PD", label: "Porter Airlines (PD)" },
  { value: "QF", label: "Qantas (QF)" },
  { value: "QR", label: "Qatar Airways (QR)" },
  { value: "AT", label: "Royal Air Maroc (AT)" },
  { value: "BI", label: "Royal Brunei Airlines (BI)" },
  { value: "RJ", label: "Royal Jordanian (RJ)" },
  { value: "FR", label: "Ryanair (FR)" },
  { value: "SK", label: "SAS (SK)" },
  { value: "LX", label: "SWISS (LX)" },
  { value: "SV", label: "Saudia (SV)" },
  { value: "TR", label: "Scoot (TR)" },
  { value: "SC", label: "Shandong Airlines (SC)" },
  { value: "FM", label: "Shanghai Airlines (FM)" },
  { value: "3U", label: "Sichuan Airlines (3U)" },
  { value: "SQ", label: "Singapore Airlines (SQ)" },
  { value: "SA", label: "South African Airways (SA)" },
  { value: "WN", label: "Southwest Airlines (WN)" },
  { value: "NK", label: "Spirit Airlines (NK)" },
  { value: "UL", label: "SriLankan Airlines (UL)" },
  { value: "DT", label: "TAAG Angola Airlines (DT)" },
  { value: "TP", label: "TAP Air Portugal (TP)" },
  { value: "RO", label: "TAROM (RO)" },
  { value: "TG", label: "Thai Airways (TG)" },
  { value: "TK", label: "Turkish Airlines (TK)" },
  { value: "PS", label: "Ukraine International Airlines (PS)" },
  { value: "UA", label: "United Airlines (UA)" },
  { value: "VN", label: "Vietnam Airlines (VN)" },
  { value: "VS", label: "Virgin Atlantic (VS)" },
  { value: "VA", label: "Virgin Australia (VA)" },
  { value: "VY", label: "Vueling (VY)" },
  { value: "PN", label: "West Air (PN)" },
  { value: "WS", label: "WestJet (WS)" },
  { value: "W6", label: "Wizz Air (W6)" },
  { value: "MF", label: "Xiamen Airlines (MF)" },
  { value: "U2", label: "easyJet (U2)" },
] as const;
